<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      height="800px"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>{{
          OpStatus == "Add"
            ? "新增版本管理"
            : OpStatus == "Modify"
            ? "修改版本管理"
            : "查看版本管理"
        }}</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <div class="option">
              <el-button v-show="IsShowConfirm" @click="handleConfirm">
                <span>提交</span>
              </el-button>
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form :model="SelectData" :rules="rules" size="small">
                <div class="formtable">
                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="24">
                      <div class="grid-content bg-purple">
                        <el-form-item label="版本信息:" prop="versionName">
                          <el-input
                            v-model="SelectData.versionName"
                            class="mx-4"
                            size="mini"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="grid-content bg-purple">
                        <el-form-item label="应用版本号:" prop="versionCode">
                          <el-input-number
                            v-model="SelectData.versionCode"
                            class="mx-4"
                            :min="1"
                            :precision="0"
                            size="mini"
                            controls-position="right"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="grid-content bg-purple">
                        <el-form-item label="系统" prop="appSystem">
                          <el-select
                            v-model="SelectData.appSystem"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in appSystemList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="grid-content bg-purple">
                        <el-form-item label="强制升级" prop="updateStatus">
                          <el-select
                            v-model="SelectData.updateStatus"
                            placeholder="请选择"
                          >
                            <el-option label="是" :value="2"></el-option>
                            <el-option label="否" :value="1"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="24" v-if="SelectData.appSystem == 'Android'">
                      <el-form-item label="安装包">
                        <el-upload
                          ref="updateImage"
                          drag
                          action="#"
                          multiple
                          :limit="1"
                          :auto-upload="false"
                          :show-file-list="true"
                          :file-list="fileList"
                          :accept="acceptName"
                          list-type="resource"
                          :on-change="changeUploadImg"
                          :on-remove="handleRemove"
                        >
                          <i class="el-icon-upload"></i>
                          <div class="el-upload__text">
                            将文件拖到此处，或<em>点击上传</em>
                          </div>
                          <template v-slot:tip>
                            <div class="el-upload__tip">
                              <span>只能上传apk文件</span>
                            </div>
                          </template>
                        </el-upload>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <div class="grid-content bg-purple">
                        <el-form-item label="版本说明：" prop="modifyContent">
                          <!-- <MyCkdeitor
                            @sendContnet="getContent"
                            :content="SelectData.modifyContent"
                          ></MyCkdeitor> -->
                          <el-input
                            v-model="SelectData.modifyContent"
                            style="width: 240px"
                            autosize
                            type="textarea"
                            placeholder="请输入版本说明"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import {
  SelectAppVersionManagementById,
  ModifyAppVersionManagement,
  AddAppVersionManagement,
} from "@api/ApiAppVersionManagement";
// import MyCkdeitor from "../RichText/MyCkdeitor.vue";
import { ossUpload } from "@/util/ossClient.js";

export default {
  name: "AppVersionManagementEdit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    GUID: {
      type: String,
      default: "",
    },
  },
  components: {
    // MyCkdeitor,
  },
  data() {
    return {
      SelectData: {
        id: 0,
        versionCode: 1,
        versionName: "",
        appSystem: "Android",
        updateStatus: 2,
        modifyContent: "",
        apkSize: 0,
        downloadUrl: "",
        status: 0,
        msg: "",
        auditor: "",
        auditTime: "",
        terminator: "",
        terminalTime: "",
      },
      IsReadonly: false,
      IsShowConfirm: true,
      IsReadonlyCode: true,
      OpStatus: "Detail",
      appSystemList: [
        { value: "IOS", label: "IOS" },
        { value: "Android", label: "安卓" },
      ],
      fileList: [],
      acceptName: ".apk", //文件格式
      rules: {
        versionCode: [
          {
            required: true,
            message: "请输入应用版本号",
            trigger: "blur",
          },
        ],
        versionName: [
          {
            required: true,
            message: "请输入版本信息",
            trigger: "blur",
          },
        ],
        modifyContent: [
          {
            required: true,
            message: "请输入版本说明",
            trigger: "blur",
          },
        ],
        appSystem: [
          {
            required: true,
            message: "请选择系统",
            trigger: "change",
          },
        ],
        updateStatus: [
          {
            required: true,
            message: "请选择是否强制升级",
            trigger: "change",
          },
        ],
      },
    };
  },

  created() {},
  mounted() {},
  methods: {
    /**
     * type==> Add,Modify,Detail
     */
    loadDataById(id, type) {
      const _this = this;
      _this.IsReadonly = false;
      _this.IsShowConfirm = true;
      _this.OpStatus = type;
      _this.IsReadonlyCode = true;

      if (type == "Add") {
        _this.IsReadonlyCode = false;
        _this.SelectData = {};
        _this.SelectData.type = 1;
        _this.SelectData = {
          id: 0,
          versionCode: 1,
          versionName: "",
          appSystem: "Android",
          updateStatus: 2,
          modifyContent: "",
          apkSize: 0,
          downloadUrl: "",
          status: 0,
          msg: "",
          auditor: "",
          auditTime: "",
          terminator: "",
          terminalTime: "",
        };
        return;
      } else if (type == "Modify") {
        _this.IsReadonlyCode = false;
      } else if (type == "Detail") {
        _this.IsReadonly = true;
        _this.IsShowConfirm = false;
      }

      SelectAppVersionManagementById(id).then(function (data) {
        let resultData = data;
        _this.SelectData = resultData;
      });
    },
    handleSelect(item) {
      console.log(item);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },

    handleClose() {
      this.SelectData = {};
      this.$emit("close-dialog");
      if (this.$refs.updateImage) {
        this.$refs.updateImage.clearFiles();
      }
    },
    handleCancel() {
      this.SelectData = {};
      this.$emit("handle-cancel");
      if (this.$refs.updateImage) {
        this.$refs.updateImage.clearFiles();
      }
    },
    async handleConfirm() {
      var _this = this;
      let loading = _this.GetLoading("保存中...");
      let checkResout = await this.validate();
      if (!checkResout) {
        loading.close();
        return;
      }

      if (_this.OpStatus == "Add") {
        let USER_INFO = JSON.parse(localStorage.getItem("USER_INFO"));
        let params = {
          creatorName: USER_INFO.UserName,
          ..._this.SelectData,
        };
        AddAppVersionManagement(params).then(function () {
          _this.$message.success("新增成功!");
          loading.close();
          _this.$emit("handle-confirm");
        });
      } else if (_this.OpStatus == "Modify") {
        let params = _this.SelectData;
        ModifyAppVersionManagement(params).then(function (data) {
          loading.close();
          _this.$message.success("编辑成功!");
          _this.$emit("handle-confirm");
        });
      }
    },
    async validate() {
      if (
        this.SelectData.appSystem == "Android" &&
        !this.SelectData.downloadUrl
      ) {
        this.$message.error("apk安装包是必须的!");
        return false;
      }
      return true;
    },
    //获取富文本编译器内容
    // getContent(val) {
    //   this.SelectData.modifyContent = val;
    // },
    handleRemove(file, fileList) {
      this.SelectData.downloadUrl = "";
      this.SelectData.apkSize = 0;
    },
    changeUploadImg(file) {
      let _name = file.name.split(".");
      var filetype = _name[_name.length - 1];
      let filetypeList = ["apk"];
      if (!filetypeList.includes(filetype.toLowerCase())) {
        this.$refs.updateImage.handleRemove(file);
        this.$message.error("上传格式错误");
        return false;
      } else {
        this.updateImage();
      }
    },
    //上传安卓安装包
    async updateImage() {
      let that = this;
      let files = that.$refs.updateImage.uploadFiles;
      if (files.length <= 0) {
        that.$message.warning("请先选择apk文件!");
        return;
      }

      files = that.$refs.updateImage.uploadFiles.map((el) => {
        return el.raw;
      });

      files.forEach((item) => {
        var formData = new FormData();
        var File = item;
        File.fileName = files
          .map((el) => {
            return el.name;
          })
          .join("|");
        formData.append("File", item);
        // let textArray = File.fileName.split(".");
        // let extension = "." + textArray[textArray.length - 1]; // 取后缀名
        let fileName = File.fileName;
        let loading = that.GetLoading("上传中...");
        //上传到Oss
        var _this = this;
        ossUpload(fileName, File, "5")
          .then((result) => {
            _this.SelectData.downloadUrl = fileName;
            _this.SelectData.apkSize = (File.size / 1024).toFixed(2);
          })
          .then((result) => {
            _this.$message.success("安装包上传成功!");
            loading.close();
          })
          .catch((e) => {
            loading.close();
          });
      });
    },
    GetLoading(text) {
      return this.$loading({
        lock: true,
        text: text,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
  },
};
</script>

<style lang="scss" scoped >
.select-items {
  position: relative;
  display: flex;
}

.select-item {
  height: 50px;
  flex: 33.33%;
  display: flex;
  margin: 0 10px;
}
.item-lab {
  flex: 25%;
  line-height: 50px;
  display: flex;
  position: relative;
}

.item-input {
  flex: 75%;
}

.item-lab > label {
  align-items: flex-end;
  position: absolute;
  right: 5px;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}

.priorityNum {
  text-align: left;
  margin: 10px;
}
.pictureWarn {
  margin-left: 10px;
  color: red;
}

.switch-content {
  padding-left: 25px;
}
</style>
